import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { DatePipe } from "../../pipes/date.pipe";

@Component({
  selector: 'mapfre-auditlib-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarComponent implements OnInit {

  @Input() events;
  @Input() selectionMode;
  @Input() inline: boolean = false;
  @Input() disabledDates;
  @Input() yearRange = '2000:2030'; // Este campo no afecta.
  @Output() onSelect = new EventEmitter();

  _form: UntypedFormControl;
  @Input()
  set form(f) {
    this._form = f;
    if (this._form) {
      this._form.valueChanges.subscribe(res => {
        if (res) {
          if (_.isArray(res)) {
            _.forEach(res, (r: any, index) => {
              if (r) {
                // Convertir a Date si no lo es
                let dateObj = r;
                if (typeof r === 'string') {
                  dateObj = new Date(r);
                } else if (moment.isMoment(r)) {
                  dateObj = r.toDate();
                } else if (!(r instanceof Date)) {
                  dateObj = new Date(r);
                }
                
                if (dateObj instanceof Date && !isNaN(dateObj.getTime())) {
                  dateObj.setHours(12, 0, 0, 0);
                  res[index] = dateObj;
                } else {
                  console.warn(`[Calendar] Array[${index}] - Invalid date, skipping`);
                }
              }
            });
          } else {
            // Convertir a Date si no lo es
            let dateObj = res;
            if (typeof res === 'string') {
              dateObj = new Date(res);
            } else if (moment.isMoment(res)) {
              dateObj = res.toDate();
            } else if (!(res instanceof Date)) {
              dateObj = new Date(res);
            }
            
            if (dateObj instanceof Date && !isNaN(dateObj.getTime())) {
              dateObj.setHours(12, 0, 0, 0);
              res = dateObj;
            } else {
              console.warn('[Calendar] Invalid date, cannot set hours:', res);
              return; // No actualizar si la fecha es inválida
            }
          }

          this._form.setValue(res, { emitEvent: false });
        }
      });
    }
  }
  get form() {
    return this._form;
  }

  // @Input() readonly;
  @Input() minDate;
  @Input() maxDate;
  @Input() yearNavigator = false;
  @Input() monthNavigator = false;
  @Input() appendTo;
  @Input() showButtonBar = false;
  format: string = 'dd/mm/yy'
  @Output() onClearClick = new EventEmitter();

  @Input() readonly: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['readonly'] && !changes['readonly'].firstChange) {
      this.getReadOnlyValue();
    }
  }

  constructor(public translateService: TranslateService, private readonly datePipe: DatePipe) {
    this.events = [];
    this.selectionMode = '';
    this.form = new UntypedFormControl(null, []);
    this.inline = true;
  }

  readOnlyValue


  ngOnInit() {
    if (this.translateService.currentLang?.toUpperCase() == 'EN') {
      this.format = 'mm/dd/yy'
    }
    this.getReadOnlyValue()
  }

  getReadOnlyValue() {
    const value = this.form.value;
    if (_.isArray(value) && value.length > 0) {
      const dates$ = value.filter(v => !!v).map(v => this.datePipe.transform(v, false, false));
      if (dates$.length === 0) {
        this.readOnlyValue = '';
        return;
      }
      forkJoin(dates$).subscribe((formattedDates: string[]) => {
        this.readOnlyValue = formattedDates.join(' - ');
      });
    } else {
      this.datePipe.transform(value, false, false).subscribe(date => {
        this.readOnlyValue = date;
      });
    }
  }

  matchDate(date) {
    let severity = [];
    this.events.forEach(element => {
      const dateEvent = moment(element.date).format('DD/MM/YYYY');
      const dateCalendar = moment(date).format('DD/MM/YYYY');
      if (dateEvent === dateCalendar) {
        severity.push(element.severity);
      }
    });

    return severity
  }

  select(event) {
    this.onSelect.emit(event);
  }

  clearClick(event) {
    this.onClearClick.emit(event);
  }

}
